export var TipoDeclaracion3D;
(function (TipoDeclaracion3D) {
    TipoDeclaracion3D[TipoDeclaracion3D["INCLUDE"] = 0] = "INCLUDE";
    TipoDeclaracion3D[TipoDeclaracion3D["ARREGLO"] = 1] = "ARREGLO";
    TipoDeclaracion3D[TipoDeclaracion3D["VARIABLE"] = 2] = "VARIABLE";
    TipoDeclaracion3D[TipoDeclaracion3D["MAIN"] = 3] = "MAIN";
    TipoDeclaracion3D[TipoDeclaracion3D["METODO"] = 4] = "METODO";
})(TipoDeclaracion3D || (TipoDeclaracion3D = {}));
